<template>
  <div
    class="result"
    :class="
      pageType == 'trade' || pageType == 'app' ? '' : isScroll ? '' : 'position'
    "
  >
    <div class="layout">
      <div
        v-if="result == 'SUCCESS' || result == 'PROCESSING'"
        class="sucPrompt"
      >
        <img src="@/assets/images/template/success.png">
        <span>提交成功</span>
        <!--<p>预计10分钟内到账，存款高峰可能会有延迟。</p>-->
      </div>
      <div v-if="result == 'FAIL'" class="sucPrompt">
        <img src="@/assets/images/template/abnormal.png">
        <span>{{ msg }}</span>
      </div>
      <div class="orderList">
        <ul>
          <li>
            <p>订单号</p>
            <span>{{ pno }}</span>
          </li>
          <li>
            <p>账号</p>
            <span>{{ customerno }}</span>
          </li>
          <li>
            <p>存款金额</p>
            <span>{{ payAmount }}美元</span>
          </li>
          <li>
            <p>存款时间</p>
            <span>{{ new Date(createDate).format("Y-MM-dd hh:mm:ss") }}</span>
          </li>
        </ul>
      </div>
      <div v-if="result == 'SUCCESS' || result == 'PROCESSING'">
        <div v-if="pageType == 'trade' || pageType == 'app'" class="tradeBtn">
          <p class="submit" @click="goAppMarket">去交易</p>
          <span
            v-if="sourceType != 'old'"
            @click="goAppTrade"
          >查看可用资金</span>
        </div>
        <div v-else class="btnItem">
          <span class="leftBtn" @click="goRecord">查看记录</span>
          <span
            v-sa="{
              ClickDeposit: {
                PType:
                  pageType == 'app'
                    ? 'app端'
                    : pageType == 'trade'
                      ? 'H5交易'
                      : '用户中心',
                AccountType: '真实账户',
                entry: '存款成功-存款',
              },
            }"
            class="rightBtn"
            @click="goRecharge"
          >继续存款</span>
        </div>
      </div>
      <div v-else>
        <div
          v-if="result == 'FAIL'"
          class="tradeBtn"
          :class="
            pageType == 'trade' || pageType == 'app' ? 'paddingBottom' : ''
          "
        >
          <p
            v-sa="{
              ClickDeposit: {
                PType:
                  pageType == 'app'
                    ? 'app端'
                    : pageType == 'trade'
                      ? 'H5交易'
                      : '用户中心',
                AccountType: '真实账户',
                entry: '存款失败-存款',
              },
            }"
            class="submit"
            @click="goRecharge"
          >
            重新存款
          </p>
        </div>
      </div>
    </div>
    <!--<div class="tradeInfo" v-if="pageType=='trade'||pageType=='app'">
        <div class="title"><span>大家都在买</span><p>更多</p></div>
        <div class="tradeCon">
            <ul>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price rise"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
            </ul>
        </div>
    </div>-->
    <Chat />
    <ToHome />
  </div>
</template>

<script>
require('@/assets/css/result.css')
import Chat from '@/view/module/Chat.vue'
import ToHome from '@/view/module/ToHome.vue'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
export default {
  name: 'RechargeResult',
  components: { Chat, ToHome },
  computed: {
    ...mapState(['pageType', 'rechargeData', 'sourceType'])
  },
  data() {
    const u = navigator.userAgent
    return {
      result: this.$route.query.result || '',
      pno: this.$route.query.pno || '',
      customerno: this.$route.query.customerno || '',
      payAmount: this.$route.query.payAmount || '',
      createDate: this.$route.query.createDate || '',
      msg: decodeURIComponent(this.$route.query.msg).replace(/\+/g, ' ') || '',
      isScroll: '',
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      uicode: '3485745,3420465,3551281,3354673'
    }
  },
  mounted() {
    console.log(this)
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    this.$nextTick(() => {
      // if (this.pageType == "app") setTimeout(this.AppHotData(),1000);
    })
    window.setHotDataResult = (...arg) => {
      this.setHotDataResult(...arg)
    }
    if (this.result == 'SUCCESS' || this.result == 'PROCESSING') {
      this.$store.dispatch('setRechargeData', {})
      this.$fireBase.logEvent('deposit_success', {
        platform_type:
          this.pageType == 'app'
            ? 'app端'
            : this.pageType == 'trade'
              ? 'H5交易'
              : '用户中心',
        deposit_type: 'this.payName',
        time: utils.getThisTime(),
        deposit_amount: this.payAmount,
        is_success: '成功',
        url: window.location.href
      })
    }
    if (this.result == 'FAIL') {
      this.$fireBase.logEvent('deposit_success', {
        platform_type:
          this.pageType == 'app'
            ? 'app端'
            : this.pageType == 'trade'
              ? 'H5交易'
              : '用户中心',
        deposit_type: 'this.payName',
        time: utils.getThisTime(),
        deposit_amount: this.payAmount,
        is_success: '失败',
        url: window.location.href
      })
    }
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    if (this.result == 'SUCCESS' || this.result == 'PROCESSING') {
      this.$store.dispatch('setRechargeData', {})
      this.$fireBase.logEvent('deposit_success', {
        platform_type:
          this.pageType == 'app'
            ? 'app端'
            : this.pageType == 'trade'
              ? 'H5交易'
              : '用户中心',
        deposit_type: 'this.payName',
        time: utils.getThisTime(),
        deposit_amount: this.payAmount,
        is_success: '成功',
        url: window.location.href
      })
    }
    if (this.result == 'FAIL') {
      this.$fireBase.logEvent('deposit_success', {
        platform_type:
          this.pageType == 'app'
            ? 'app端'
            : this.pageType == 'trade'
              ? 'H5交易'
              : '用户中心',
        deposit_type: 'this.payName',
        time: utils.getThisTime(),
        deposit_amount: this.payAmount,
        is_success: '失败',
        url: window.location.href
      })
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    goRecord() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      if (this.pageType == 'app') {
        this.$router.push({
          path: '/home/record',
          query: { typeName: 'deposit' }
        })
      } else this.$router.push({ path: '/home/record' })
    },
    goRecharge() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/recharge' })
    },
    hasScrollbar() {
      if (
        document.body.scrollHeight >
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    goAppTrade() {
      window.location.href = 'https://www.cfwell.com/?intercept_trade'
    },
    goAppMarket() {
      window.location.href = 'https://www.cfwell.com/?intercept_market'
    },
    AppHotData() {
      try {
        let v
        if (this.isIOS) {
          v = window.hotData()
        } else {
          v = window.uiObject.hotData()
        }
      } catch (e) {
        alert(e)
      }
    },
    setHotDataResult(uicode) {}
  }
}
</script>
